import { render, staticRenderFns } from "./joinrequest.vue?vue&type=template&id=88948750&"
import script from "./joinrequest.ts?vue&type=script&lang=js&"
export * from "./joinrequest.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports